import { QuestionImageCacheService } from './question-image-cache.service';

export function provideQuestionCacheImageService() {
  return [QuestionImageCacheService];
}
